import type { Schema } from "@/shared/components/Form/types";
import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { StreamEntrypointShowQuery } from "@/admin/entities/streamEntrypoints";
import type { StreamEntrypointShowQueryQueryType } from "@/types/graphql/admin.generated";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

export const filterSchema: Schema = {
  search: {
    label: "Поиск",
    type: "text",
    placeholder: "Поиск по названию...",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "primary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};

export const editSchema: EditSchemaDefinition = {
  details: {
    label: "Детали",
    type: "show" as const,
    getTitle: (data: unknown) => {
      const { streamEntrypoint } = data as StreamEntrypointShowQueryQueryType;
      if (!streamEntrypoint) return null;
      return streamEntrypoint.title;
    },
    showQuery: StreamEntrypointShowQuery,
  },
} as const;
